import { useMutation } from '@apollo/client';
import React, { useMemo, useState } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useIntl } from 'react-intl';
import { DELETE_TRANSACTION_TYPE } from 'services/graphql/mutations/transactionTypes';
import { formatMessage } from 'utils/IntlMessages';

import { IServiceRelatedModalProps } from '../types';

const CreateTransactionTypeModal: React.FC<IServiceRelatedModalProps> = ({
  modalVisible,
  closeModal,
  callbackOnDeleteSuccess,
  activeTransactionType,
}) => {
  const intl = useIntl();

  const [deleteTransactionType] = useMutation(DELETE_TRANSACTION_TYPE);

  const [error, setError] = useState<string | null>(null);

  const onDeleteTransactionTypeConfirm = async () => {
    if (error) {
      setError(null);
      closeModal();
      return;
    }
    try {
      await deleteTransactionType({
        variables: {
          id: activeTransactionType?.id,
        },
      });
      callbackOnDeleteSuccess?.();
    } catch (err) {
      setError(err?.message || 'Unknown error!');
    }
  };

  const deleteAlertVisible = useMemo(() => !!modalVisible?.includes('delete-transaction-type'), [modalVisible]);

  return (
    <>
      {/* {!modalVisible?.includes('delete') && (
        <DefaultModal
          props={{
            title: <FormattedMessage id={titleId} />,
            visible: modalVisible?.includes('transaction-type'),
            onCancel: closeModal,
            bodyStyle: { padding: 0 },
            destroyOnClose: true,
          }}>
          <CreateTransactionTypeForm
            activeService={activeService}
            refetch={refetch}
            callbackOnCreateSuccess={callbackOnCreateSuccess}
            callbackOnEditSuccess={callbackOnEditSuccess}
            // callbackOnDeleteSuccess={modalVisible?.includes('delete') ? callbackOnDeleteSuccess : undefined}
            activeTransactionType={modalVisible?.includes('edit') ? activeTransactionType : undefined}
          />
        </DefaultModal>
      )} */}
      <SweetAlert
        show={deleteAlertVisible || !!error}
        warning={!error}
        error={!!error}
        title={!error ? formatMessage(intl, 'appModule.deleteRecordTitle') : formatMessage(intl, 'sweetAlerts.error')}
        confirmBtnText={!error ? formatMessage(intl, 'appModule.delete') : formatMessage(intl, 'sweetAlerts.ok')}
        onConfirm={onDeleteTransactionTypeConfirm}
        onCancel={closeModal}
        showCancel={!error}
        reverseButtons>
        {!error ? formatMessage(intl, 'appModule.deleteRecordBody') : error}
      </SweetAlert>
    </>
  );
};
export default React.memo(CreateTransactionTypeModal);
